"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Menu = styled_components_1.default.div `
	position: ${(p) => (p.static ? "static" : "relative")};
	height: 100%;
	max-height: ${(p) => p.theme.navHeight}px;
`;
//# sourceMappingURL=Menu.styles.js.map